<template>
  <div class="saved-reset-list">
    <div class="search-title">
      <span class="fa fa-search" @click="searchSavedResets($event)"></span>
      <input-control
        v-model="searchTextSavedResetsInput"
        type="text"
        :no-title="true"
        name="search_title"
        :placeholder="$t('reset.placeholder.title_reset')"
        @keypress="onEnter($event, searchSavedResets)"
        class="search-title-text"
      />
    </div>
    <div class="saved-resets-list-container" @scroll="onScrollSavedResets">
      <div v-if="savedResetsTotal === 0" class="no-data">
        {{ $t('common.text.no_data') }}
      </div>
      <div v-else class="saved-resets-list-wrapper">
        <div v-for="(savedReset, savedResetIndex) in savedResets" :key="'saved-reset-' + savedResetIndex" class="reset-item saved-reset-item">
          <div class="title" @click="selectSavedReset(savedReset, $event)">
            <div class="title-content">
              {{ savedReset.nm }}
            </div>
          </div>
          <div class="date" @click="selectSavedReset(savedReset, $event)">
            {{ getTotalDateCount(savedReset) }}일
          </div>
          <div class="name" @click="selectSavedReset(savedReset, $event)">
            {{ savedReset.userNm }}
          </div>
          <div class="summary-data" @click="selectSavedReset(savedReset, $event)">
            {{ $t('reset.text.amount') }} : {{ getResetPrice(savedReset) }}원<br>
            {{ $t('reset.text.intake_rate') }} : {{ getIntakeRate(savedReset) }}%
          </div>
          <input-control
            v-model="savedReset.checked"
            name="delete_flag"
            type="checkbox"
            :is-switch="false"
            title=" "
          />
        </div>
        <div class="clear" />
        <div v-if="savedResetsTotal !== undefined && savedResetsTotal > savedResetsLoaded" class="saved-resets-loading resets-loading">
          <div class="clear" />
          <img src="/img/ajax-loader-white-bg.gif" alt="Loading">
          <strong>{{ $t('common.text.loading') }}</strong>
        </div>
      </div>
    </div>
    <div class="controls bottom-fixed-controls">
      <div lass="button-area">
        <button class="btn no-border" :disabled="!isResetSelected()" @click="showDeleteConfirmModal($event)">
          {{ $t('common.button.delete') }}
        </button>
      </div>
    </div>
    <b-modal
      id="delete-confirm-modal"
      ref="deleteConfirmModalRef"
      modal-class="simple-design"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :centered="true"
      :no-close-on-backdrop="true"
      @ok="deleteReset($event)"
    >
      <p class="my-4" v-html="$t('common.modal.text.delete_confirm')" />
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    initData: {
      type: Object,
      default: undefined
    },
    initConditions: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      savedResets: undefined,
      savedResetFirstId: undefined,
      savedResetsTotal: undefined,
      savedResetsLoaded: undefined,
      searchTextSavedResetsInput: '',
      savedResetOrder: 'id',
      savedResetDirection: 'desc',
      searchSexdstnCodeInput: '',
      searchAgeCodeInput: '',
      searchReasonsForInputControlInput: [],
      reasonOptions: [],
      sexdstnCodes: [],
      ageCodes: []
    }
  },
  watch: {
    searchTextSavedResetsInput: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    },
    savedResetOrder: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    },
    savedResetDirection: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    },
    searchSexdstnCodeInput: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    },
    searchAgeCodeInput: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    },
    searchReasonsForInputControlInput: {
      handler(newVal, oldVal) {
        this.emitConditions()
      },
      deep: true
    }
  },
  async mounted() {
    this.ageCodes = await this.getCodes('age')
    this.sexdstnCodes = await this.getCodes('sex_distinction')
    this.resetReasonCodes = await this.getCodes('reset_reason')
    for (let i = 0; i < this.resetReasonCodes.length; i++) {
      const code = this.resetReasonCodes[i]
      this.reasonOptions.push({
        value: code.codeId,
        text: this.$t('code.nm.' + code.codeId)
      })
    }
    if (this.initConditions) {
      for (const key in this.initConditions) {
        this[key] = this.initConditions[key]
      }
      if (this.initData) {
        this.initializeWithData()
        return
      }
      this.searchSavedResets()
    } else {
      if (this.initData) {
        this.initializeWithData()
        return
      }
      this.loadSavedResets(true)
    }
  },
  methods: {
    emitConditions() {
      this.$emit('condition-changed', {
        searchTextSavedResetsInput: this.searchTextSavedResetsInput,
        savedResetOrder: this.savedResetOrder,
        savedResetDirection: this.savedResetDirection,
        searchSexdstnCodeInput: this.searchSexdstnCodeInput,
        searchAgeCodeInput: this.searchAgeCodeInput,
        searchReasonsForInputControlInput: this
          .searchReasonsForInputControlInput
      })
    },
    showDeleteConfirmModal(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.showModal('deleteConfirmModalRef')
    },
    deleteReset(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      const ids = []
      if (this.savedResets && this.savedResets.length > 0) {
        for (let i = 0; i < this.savedResets.length; i++) {
          if (this.savedResets[i].checked === 'Y') {
            ids.push(this.savedResets[i].id)
          }
        }
      }
      this.$axios.$put('/reset/deleteResets', ids).then(response => {
        if (response.resultCode === 'success') {
          this.loadSavedResets(true)
          this.hideModal('deleteConfirmModalRef')
          this.$toast.info(this.$t(response.message, response.params))
        } else {
          console.error(this.$t(response.message, response.params))
          this.$toast.error(this.$t(response.message, response.params))
        }
      })
    },
    selectSavedReset(reset, e) {
      this.$emit('select-reset', {
        reset: reset,
        e: e
      })
    },
    isResetSelected() {
      if (this.savedResets && this.savedResets.length > 0) {
        for (let i = 0; i < this.savedResets.length; i++) {
          if (this.savedResets[i].checked === 'Y') {
            return true
          }
        }
      }
      return false
    },
    searchSavedResets(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.searchTextSavedResets = this.searchTextSavedResetsInput
      this.loadSavedResets(true)
    },
    async loadSavedResets(refresh) {
      if (refresh) {
        this.savedResets = undefined
        this.savedResetFirstId = undefined
        this.savedResetsTotal = undefined
        this.savedResetsLoaded = 0
        window.savedResetsPage = -1
      }
      if (this.savedResetsTotal === this.savedResetsLoaded) {
        return
      }
      if (this.loading) {
        return
      }
      this.loading = true
      window.savedResetsPage++
      let url = '/reset/resets?myFlag=Y&pageNo=' + window.savedResetsPage
      if (this.savedResetFirstId) {
        url += '&firstId=' + this.savedResetFirstId
      }
      if (this.searchTextSavedResets) {
        url += '&searchText=' + encodeURIComponent(this.searchTextSavedResets)
      }
      const res = await this.$axios.$get(url)
      if (!this.savedResets) {
        this.savedResets = res.data.list
      } else {
        this.savedResets = this.savedResets.concat(res.data.list)
      }
      this.savedResetsTotal = res.data.totalSize
      if (!this.savedResetFirstId) {
        this.savedResetFirstId = res.data.firstId
      }
      if (this.savedResets) {
        this.savedResetsLoaded = this.savedResets.length
      }
      this.$nextTick(() => {
        this.loading = false
        this.onScrollSavedResets()
      })
    },
    emitScrollAndData() {
      this.$emit('scroll-and-data', {
        list: this.savedResets,
        total: this.savedResetsTotal,
        firstId: this.savedResetFirstId,
        loaded: this.savedResetsLoaded,
        scrolledY: this.scrolledY
      })
    },
    initializeWithData() {
      this.savedResets = this.initData.list
      this.savedResetsTotal = this.initData.total
      this.savedResetFirstId = this.initData.firstId
      this.savedResetsLoaded = this.initData.loaded
      this.$nextTick(() => {
        $(this.$el)
          .find('.saved-resets-list-container')
          .scrollTop(this.initData.scrolledY)
      })
    },
    onScrollSavedResets(e) {
      const comp =
        $('.saved-resets-list-wrapper').height() -
        $('.saved-resets-list-container').height()
      const top = $('.saved-resets-list-container').scrollTop()
      if (comp - top < 50) {
        this.loadSavedResets(false)
      }
      this.scrolledY = top
      this.emitScrollAndData()
    }
  }
}
</script>

<style scoped>
.saved-resets-list-container {
  height: calc(100vh - 22.5rem);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 1.1666666rem;
  padding-bottom: 4rem;
}
.search-title .fa {
  color: #360ea6;
  font-size: 1.5rem;
  margin-left: 1.708333333333333rem;
  position: absolute;
  z-index: 4;
}
.search-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.708333333333333rem;
  background: #f1f1f1;
}
.search-title {
  padding: 1rem 0;
}
.search-title >>> input[type='text']::placeholder,
.search-title >>> input[type='text'] {
  font-size: 0.95rem !important;
}
.search-title >>> input[type='text'] {
  padding: 0 0.7rem;
  padding-left: 2.6rem;
  height: 2.291666666666667rem;
}
.search-title-text {
  height: 2.291666666666667rem;
  border: none;
  margin-left: 1rem;
  width: calc(100vw - 2rem);
}
.search-title-text >>> input {
  border: none !important;
  box-shadow: none !important;
}
.reset-item .name {
  font-weight: bold;
}
.reset-item .title {
  font-weight: lighter;
  overflow: hidden;
  line-height: 1.2rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.reset-item .title .title-content {
  max-width: 65%;
  max-height: 2rem;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  text-align: center;

  word-wrap: break-word;
  display: block;
  -webkit-line-clamp: 2; /* ellipsis line */
  -webkit-box-orient: vertical;
  white-space: nowrap;
  margin-top: 0.4rem;

  /* webkit 엔진을 사용하지 않는 브라우저를 위한 속성. */
  /* height = line-height * line = 1.2em * 3 = 3.6em  */
  line-height: 1rem;
  font-size: 1rem;
}
.reset-item .name,
.reset-item .title {
  font-size: 0.95rem;
}
.reset-item .registration-operation-date {
  font-size: 0.95rem;
  width: 9.3rem;
}
.reset-item .name-and-title {
  width: calc(100% - 9.3rem);
}
.resets-loading {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .input-control {
  min-height: auto;
  margin-bottom: 0;
}
.no-data {
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10rem;
}

.selectors {
  margin-bottom: 0.6rem;
  display: flex;
  justify-content: space-between;
}
.selectors > select {
  margin-right: 0.4rem;
}
.reset-reason-select {
  width: calc(100% - 11.33rem);
  margin-right: 0 !important;
}
.saved-reset-item {
  float: left;
  width: calc(100% / 3);
  margin-bottom: 1rem;
}
.saved-reset-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.saved-reset-item .title {
  width: 6.8583rem;
  height: 3.4291rem;
  border-top-left-radius: 3.4291rem;
  border-top-right-radius: 3.4291rem;
  background-color: #03d5ca;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1rem;
}
.saved-reset-item .date {
  width: 6.8583rem;
  height: 3.4291rem;
  border-bottom-left-radius: 3.4291rem;
  border-bottom-right-radius: 3.4291rem;
  background-color: #dbdbdb;
  padding-top: 1rem;
  text-align: center;
  color: #999999;
  font-size: 0.95rem;
  letter-spacing: -0.1rem;
}
.saved-reset-item .name {
  font-size: 0.95rem;
  padding: 0.3rem 0;
}
.saved-reset-item:nth-child(2n) .title {
  background-color: #01a3fc;
}
.saved-reset-item:nth-child(3n + 1) {
  clear: both;
}
.saved-reset-item .summary-data {
  font-weight: lighter;
  font-size: 0.95rem;
  line-height: 1.2rem;
  color: #999999;
}
.controls {
  position: fixed;
  left: 0;
  bottom: 4rem;
  z-index: 2;
  display: flex;
  align-items: center;
  width: 100vw;
  justify-content: center;
  padding: 1.3166rem 1.5rem;
  background: white;
}
.controls .btn {
  background: #360ea6;
  color: white;
  border-radius: 0.558rem;
  font-size: 0.883rem;
  height: 2.358rem;
  margin: 0 0.3rem;
  width: 6.7333rem;
}
>>> input {
  z-index: 1;
}
>>> .custom-control-label::before,
>>> .custom-control-label::after {
  top: 0.15rem;
}
>>> .custom-control-label::before {
  border-radius: 0.7rem;
  border-color: #360ea6;
  width: 1.2916rem;
  height: 1.2916rem;
}
>>> .custom-control-label::after {
  background-position: 0.3rem 0.3rem;
  background-size: 70%;
}
</style>
